<button mat-button [routerLink]="redirectRoute" [queryParams]="queryParams">
  <i [ngClass]="icon ? icon : 'fas fa-arrow-left'" class="mr-2"></i>
  {{ text }}
</button>
